

import en from 'config/strings'
import { validateEmail } from 'utils/validation'

const validateIsAuth = (values = {}) => {
    const errors = {}

    if (values) {
        if (!values.ticket_type) {
            errors.ticket_type = en.require()
        }
        if (!values.description) {
            errors.description = en.require()
        }
        if (!values.title) {
            errors.title = en.require()
        }
        if (!values.priority) {
            errors.priority = en.require()
        }
    }

    return errors;
}

const validate = (values = {}) => {
    const errors = {}

    if (values) {
        if (!values.description) {
            errors.description = en.require()
        }
        if (!values.email) {
            errors.email = en.require()
        }
        if (!values.title) {
            errors.title = en.require()
        }
    }

    return errors;
}

const validate1 = (values) => {
    const errors = {}

    if (values) {
        if (!values.ticket_type) {
            errors.ticket_type = en.require()
        }
        if (!values.description) {
            errors.description = en.require()
        }
        if (!values.title) {
            errors.title = en.require()
        }
        if (!values.priority) {
            errors.priority = en.require()
        }
        errors.email = validateEmail(values.email)
    }

    return errors;
}

export { validate1 }

export { validate, validateIsAuth }

